import { useRef } from 'react';
import { ColorPicker } from 'primereact/colorpicker';
import { InputText } from 'primereact/inputtext';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Palette } from 'lucide-react';

const CreativeColorPicker = ({
  widgetFormik,
  action,
  colorPickerId,
  colorPickerName,
}) => {
  const op = useRef(null);

  const currentColor = widgetFormik?.values?.custom_properties?.[
    colorPickerId
  ]?.startsWith('#')
    ? widgetFormik?.values?.custom_properties?.[colorPickerId]
    : widgetFormik?.values?.custom_properties?.[colorPickerId]
      ? `#${widgetFormik.values.custom_properties[colorPickerId]}`
      : '';

  const handleColorChange = e => {
    widgetFormik.setFieldValue('custom_properties', {
      ...widgetFormik.values.custom_properties,
      [colorPickerId]: `#${e.value}`,
    });
  };

  return (
    <div className="flex align-items-center gap-1 w-full">
      <div
        className="flex align-items-center justify-content-center w-3rem h-3rem border-round border-1 border-200 cursor-pointer"
        style={{ backgroundColor: currentColor }}
        onClick={e => action !== 'view' && op.current.toggle(e)}
      >
        <Palette className="w-5 h-5" />
      </div>
      <span className="p-float-label w-full">
        <InputText
          name={colorPickerId}
          value={currentColor}
          disabled={action === 'view'}
          onChange={e => {
            let value = e.target.value.trim();

            if (/^[0-9A-Fa-f]+$/.test(value) && !value.startsWith('#')) {
              value = `#${value}`;
            }
            widgetFormik.setFieldValue('custom_properties', {
              ...widgetFormik.values.custom_properties,
              [colorPickerId]: value,
            });
          }}
          className="w-full"
        />
        <label
          htmlFor={colorPickerId}
          className="text-xs white-space-normal"
          style={{
            maxWidth: '90%',
            wordBreak: 'break-word',
          }}
        >
          {colorPickerName}{' '}
        </label>
      </span>

      <OverlayPanel ref={op} dismissable pt={{ content: { className: 'p-2' } }}>
        <ColorPicker
          inline
          value={currentColor}
          disabled={action === 'view'}
          onChange={handleColorChange}
        />
      </OverlayPanel>
    </div>
  );
};

export default CreativeColorPicker;
